var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-panel',{staticClass:"panel-wrapper",attrs:{"title":_vm.title,"hide-button":true}},[_vm._t("default",function(){return [_c('div',{staticClass:"description"},[_vm._v(" "+_vm._s(_vm.description)+" ")])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }